var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c(
        "search-form",
        {
          attrs: { formConfig: _vm.formConfig, source: _vm.searchData },
          on: {
            handleSearchJsf: _vm.handleSearchJsf,
            handleSearchCst: _vm.handleSearchCst,
            handleSearchKlf: _vm.handleSearchKlf,
            handleSearchZff: _vm.handleSearchZff,
            search: _vm.search
          }
        },
        [
          _vm.tabType == "pendingReceipt"
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-blue-line",
                      attrs: { disabled: _vm.selectedRowKeys.length == 0 },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("撤销")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabType != "goldSearch" &&
          _vm.tabType != "goldcheckPending" &&
          _vm.tabType != "goldpay"
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: { type: "primary" },
                      on: { click: _vm.onExport }
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabType == "goldpayPendingReceipt"
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-blue-line",
                      attrs: { disabled: _vm.selectedRowKeys.length == 0 },
                      on: { click: _vm.cancelPay }
                    },
                    [_vm._v("撤销")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabType == "goldSearch"
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-blue-line",
                      attrs: { disabled: _vm.tableData.length == 0 },
                      on: { click: _vm.goldListExport }
                    },
                    [_vm._v("查询结果导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-blue-line",
                      attrs: { disabled: _vm.tableData.length == 0 },
                      on: { click: _vm.goldPayRecordExport }
                    },
                    [_vm._v("追溯记录导出")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabType == "goldcheckPending"
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        loading: _vm.checkLoad,
                        type: "primary",
                        disabled:
                          !_vm.selectedRowKeys.length ||
                          (!_vm.isPromiseGoldcheck && _vm.selectNeedSign())
                      },
                      on: { click: _vm.singIn }
                    },
                    [_vm._v("签收")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-blue-line",
                      attrs: {
                        loading: _vm.checkLoadCancel,
                        disabled:
                          !_vm.selectedRowKeys.length ||
                          (!_vm.isPromiseGoldcheck && _vm.selectNeedSign())
                      },
                      on: { click: _vm.singOut }
                    },
                    [_vm._v("拒绝")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.tabType == "goldcheckPending"
        ? _c(
            "div",
            [
              _c(
                "a-checkbox",
                {
                  staticStyle: { margin: "0 0 16px 0" },
                  model: {
                    value: _vm.isPromiseGoldcheck,
                    callback: function($$v) {
                      _vm.isPromiseGoldcheck = $$v
                    },
                    expression: "isPromiseGoldcheck"
                  }
                },
                [_vm._v("已阅读并同意所勾选的《转让协议》")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabType == "goldpay"
        ? _c(
            "div",
            { staticStyle: { background: "#fff", "padding-top": "16px" } },
            [
              _c(
                "div",
                {
                  staticClass: "spaceLeft",
                  staticStyle: { margin: "0 0 16px 16px" }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: {
                        name: "radioGroup",
                        "default-value": _vm.payRaio
                      },
                      model: {
                        value: _vm.payRaio,
                        callback: function($$v) {
                          _vm.payRaio = $$v
                        },
                        expression: "payRaio"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: "circle" } }, [
                        _vm._v("圈子")
                      ]),
                      _vm._v(" "),
                      _c("a-radio", { attrs: { value: "typing" } }, [
                        _vm._v("键入")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "spaceLeft" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "240px",
                            "margin-right": "16px"
                          }
                        },
                        [
                          _vm.payRaio == "typing"
                            ? _c("select-search", {
                                attrs: {
                                  searchSource: true,
                                  dataSource: _vm.recPersonListType,
                                  headNameFirst: "客户名称",
                                  headNameSecond: "社会信用代码",
                                  valuePorp: "orgCode",
                                  labelPorp: "userName"
                                },
                                on: { handleSearch: _vm.handleSearchType },
                                model: {
                                  value: _vm.recPersonInfoType,
                                  callback: function($$v) {
                                    _vm.recPersonInfoType = $$v
                                  },
                                  expression: "recPersonInfoType"
                                }
                              })
                            : _c("select-search", {
                                attrs: {
                                  searchSource: true,
                                  dataSource: _vm.recPersonList,
                                  headNameFirst: "客户名称",
                                  headNameSecond: "社会信用代码",
                                  valuePorp: "customerOrgCode",
                                  labelPorp: "customerName"
                                },
                                on: { handleSearch: _vm.getCircleList },
                                model: {
                                  value: _vm.recPersonInfo,
                                  callback: function($$v) {
                                    _vm.recPersonInfo = $$v
                                  },
                                  expression: "recPersonInfo"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "search-btn-item",
                          attrs: {
                            disabled: !_vm.payDisabled,
                            type: "primary"
                          },
                          on: { click: _vm.showModalPay }
                        },
                        [_vm._v("流转")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  staticStyle: { margin: "0 0 16px 16px" },
                  model: {
                    value: _vm.isPromise,
                    callback: function($$v) {
                      _vm.isPromise = $$v
                    },
                    expression: "isPromise"
                  }
                },
                [_vm._v("已阅读并同意所勾选的《转让协议》")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.selectedRows.length
            ? _c("div", { staticClass: "table-check-bar" }, [
                _vm._v("\n      已选择：\n      "),
                _c("span", { staticClass: "text-color-blue" }, [
                  _vm._v(_vm._s(_vm.selectedRows.length) + " 条")
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.selectName || "祺信面额") +
                    "：\n      "
                ),
                _vm.tabType == "sellerExpired"
                  ? _c("span", { staticClass: "text-color-orange" }, [
                      _vm._v(_vm._s(_vm.totalPayable(_vm.selectedRows)) + " 元")
                    ])
                  : _c("span", { staticClass: "text-color-orange" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("splitK")(
                            _vm.totalPayable(_vm.selectedRows, _vm.selectProp)
                          )
                        ) + " 元"
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-table",
            {
              attrs: {
                size: "middle",
                columns: _vm.columns,
                "row-key": function(record) {
                  return record.id
                },
                "data-source": _vm.tableData,
                pagination: _vm.pagination,
                loading: _vm.loading,
                bordered: "",
                locale: { emptyText: "暂无数据" },
                "row-selection": _vm.tableSelect
              },
              on: { change: _vm.handleTableChange },
              scopedSlots: _vm._u([
                {
                  key: "guarantorName",
                  fn: function(text, record) {
                    return [
                      record.guarantorName
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(record.guarantorName) +
                                "\n        "
                            )
                          ])
                        : _c("span", [_vm._v("--")])
                    ]
                  }
                },
                {
                  key: "gldAmt",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("splitK")(text)))]
                  }
                },
                {
                  key: "gldBal",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("splitK")(text)))]
                  }
                },
                {
                  key: "exDay",
                  fn: function(text) {
                    return [
                      _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                    ]
                  }
                },
                {
                  key: "residueDays",
                  fn: function(text, record) {
                    return [_vm._v(_vm._s(_vm.getDaysFormNow(record.exDay)))]
                  }
                },
                {
                  key: "estbDay",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(record.estbDay, "YYYY-mm-dd")
                        )
                      )
                    ]
                  }
                },
                {
                  key: "signToacptDay",
                  fn: function(text) {
                    return [
                      _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                    ]
                  }
                },
                {
                  key: "createTime",
                  fn: function(text) {
                    return [
                      _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                    ]
                  }
                },
                {
                  key: "canBeModified",
                  fn: function(text) {
                    return [_vm._v(_vm._s(_vm._f("gbCbmTrans")(text)))]
                  }
                },
                {
                  key: "gldStCd",
                  fn: function(text, record) {
                    return [
                      _c(
                        "div",
                        { staticClass: "spaceCenter" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm._f("GbGldStCdTrans")(text)) +
                              "\n          "
                          ),
                          _c(
                            "a-popover",
                            { attrs: { title: "拒绝原因" } },
                            [
                              _c("template", { slot: "content" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#666",
                                      "max-width": "200px"
                                    }
                                  },
                                  [_vm._v(_vm._s(record.opin || ""))]
                                )
                              ]),
                              _vm._v(" "),
                              record.gldStCd == 4 && record.opin
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "payable-icon",
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href": "#gold-icon-tishi"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  }
                },
                {
                  key: "openType",
                  fn: function(text, record) {
                    return [
                      _c("div", { staticClass: "spaceCenter" }, [
                        record.openType
                          ? _c("div", [
                              record.openType == 0
                                ? _c("span", [_vm._v("无")])
                                : _vm._e(),
                              _vm._v(" "),
                              record.openType == 1
                                ? _c("span", [_vm._v("有")])
                                : _vm._e()
                            ])
                          : _c("span", [_vm._v("--")])
                      ])
                    ]
                  }
                },
                {
                  key: "odueCd",
                  fn: function(text) {
                    return [_vm._v(_vm._s(text == 1 ? "是" : "否"))]
                  }
                },
                {
                  key: "payAmt",
                  fn: function(text, record) {
                    return [
                      _c("a-input", {
                        staticClass: "text-center",
                        on: {
                          blur: function($event) {
                            return _vm.payAmtCheck(record)
                          }
                        },
                        model: {
                          value: record.payAmt,
                          callback: function($$v) {
                            _vm.$set(record, "payAmt", $$v)
                          },
                          expression: "record.payAmt"
                        }
                      }),
                      _vm._v(" "),
                      !record.payAmtCheck
                        ? _c(
                            "p",
                            { staticClass: "text-color-orange text-center" },
                            [
                              _vm._v(
                                "输入金额不能大于" +
                                  _vm._s(_vm._f("splitK")(record.gldBal)) +
                                  "元"
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "operation",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toPageDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      ),
                      _vm._v(" "),
                      _vm.tabType === "sellerSigned"
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getPdf(record)
                                }
                              }
                            },
                            [_vm._v("凭证")]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "operationChange",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toPageDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      ),
                      _vm._v(" "),
                      record.canBeModified == 1 && _vm.checkInTime(record)
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toChange(record)
                                }
                              }
                            },
                            [_vm._v("变更")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.getPdf(record)
                            }
                          }
                        },
                        [_vm._v("凭证")]
                      )
                    ]
                  }
                },
                {
                  key: "operationPay",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toPageDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.selectedRowKeys.indexOf(record.id) > -1,
                              expression:
                                "selectedRowKeys.indexOf(record.id) > -1"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.toTransferContract(record)
                            }
                          }
                        },
                        [_vm._v("转让协议")]
                      )
                    ]
                  }
                },
                {
                  key: "operationCheck",
                  fn: function(text, record) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toPageDetail(record)
                            }
                          }
                        },
                        [_vm._v("详情")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: record.oriGldId != 0,
                              expression: "record.oriGldId != 0"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.toTransferContractCheck(record.gldId)
                            }
                          }
                        },
                        [_vm._v("转让协议")]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v("\n      toPageDetail\n      ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "table-total": _vm.pagination.total > 0,
                "table-total-none": _vm.pagination.total == 0
              }
            },
            [
              _vm._v("\n      共有记录：\n      "),
              _c("span", { staticClass: "text-color-blue" }, [
                _vm._v(_vm._s(_vm.pagination.total) + " 条")
              ]),
              _vm._v(_vm._s(_vm.totalName) + "：\n      "),
              _vm.tabType == "sellerExpired"
                ? _c("span", { staticClass: "text-color-orange" }, [
                    _vm._v(_vm._s(_vm.totalPayable(_vm.tableData)) + " 元")
                  ])
                : _c("span", { staticClass: "text-color-orange" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("splitK")(_vm.totalPayable(_vm.tableData))
                      ) + " 元"
                    )
                  ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "祺信开立-撤销",
            visible: _vm.modalShow,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _c("goldPasswordModal", {
            attrs: { confirmData: _vm.confirmTableData },
            on: {
              "update:confirmData": function($event) {
                _vm.confirmTableData = $event
              },
              "update:confirm-data": function($event) {
                _vm.confirmTableData = $event
              },
              ok: _vm.modalOk,
              cancel: _vm.modalCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "祺信流转-撤销",
            visible: _vm.modalShowPayCancel,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _c("goldPasswordModal", {
            attrs: { confirmData: _vm.confirmTableData },
            on: {
              "update:confirmData": function($event) {
                _vm.confirmTableData = $event
              },
              "update:confirm-data": function($event) {
                _vm.confirmTableData = $event
              },
              ok: _vm.modalOkPayCancel,
              cancel: _vm.modalCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "900px",
            title: "祺信流转",
            visible: _vm.modalShowPay,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancelPay }
        },
        [
          _vm.modalShowPay
            ? _c("goldPayModal", {
                attrs: { modalData: _vm.modalPayData },
                on: {
                  "update:modalData": function($event) {
                    _vm.modalPayData = $event
                  },
                  "update:modal-data": function($event) {
                    _vm.modalPayData = $event
                  },
                  ok: _vm.modalOkPay,
                  cancel: _vm.modalCancelPay
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            bodyStyle: { height: "540px", overflow: "auto" },
            width: "80%",
            title: "祺信转让协议",
            visible: _vm.showTransferContract,
            footer: null
          },
          on: {
            cancel: function($event) {
              _vm.showTransferContract = false
              _vm.transferContractHtml = ""
            }
          }
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.transferContractHtml) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "祺信签收-同意",
            visible: _vm.modalShowSign,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _vm.confirmTableDataSign
            ? _c("goldPasswordModal", {
                attrs: { confirmData: _vm.confirmTableDataSign },
                on: {
                  "update:confirmData": function($event) {
                    _vm.confirmTableDataSign = $event
                  },
                  "update:confirm-data": function($event) {
                    _vm.confirmTableDataSign = $event
                  },
                  ok: _vm.modalOkSign,
                  cancel: _vm.modalCancel
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "祺信签收-拒绝",
            visible: _vm.modalShowSignOut,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _vm.confirmTableDataSign
            ? _c("goldPasswordModal", {
                attrs: { confirmData: _vm.confirmTableDataSign },
                on: {
                  "update:confirmData": function($event) {
                    _vm.confirmTableDataSign = $event
                  },
                  "update:confirm-data": function($event) {
                    _vm.confirmTableDataSign = $event
                  },
                  ok: _vm.modalOkSignOut,
                  cancel: _vm.modalCancel
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("changeModal", {
        ref: "changeModal",
        attrs: { info: _vm.curItem, paramValue: _vm.paramValue },
        on: {
          "update:info": function($event) {
            _vm.curItem = $event
          },
          "update:paramValue": function($event) {
            _vm.paramValue = $event
          },
          "update:param-value": function($event) {
            _vm.paramValue = $event
          },
          success: _vm.refresh
        }
      }),
      _vm._v(" "),
      _c("pdfView", { ref: "pdfView" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-color-orange" }, [_vm._v("*")]),
      _vm._v("接收方：")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-777cc309", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777cc309","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-page.vue
// module id = lc6c
// module chunks = 1